import React, {FunctionComponent} from 'react';
import cn from 'classnames';
import IconRingSpinner from '../components/icon/IconRingSpinner';
import { Link } from 'react-router-dom';

type ButtonProps = {
  onClick?: (e: React.MouseEvent) => void
  onSubmit?: () => void
  short?: boolean
  className?: string
  narrow?: boolean
  disabled?: boolean
  loading?: boolean
  children: React.ReactNode
  to?: string
}

/**
 * Default abstract button which shouldn't be used on its own
 *
 * @constructor
 */
const Button: FunctionComponent<ButtonProps> = ({
  onClick, onSubmit, short, narrow, className, disabled, loading, to, children,
}) => {
  const height = short ? 'py-1' : 'py-2';
  const width = narrow ? 'px-4' : 'px-6';

  const fullClass = cn(
    className,
    height, width, 'justify-center rounded-md transition duration-150 ease-in-out',
  );

  const loadingEl = loading && <IconRingSpinner className="mr-1 -ml-1"/>

  const isURL = (str: string) => /^(?:\w+:)?\/\/([^\s.]+\.\S{2}|localhost[:?\d]*)\S*$/.test(str);

  if (to) {
    if (isURL(to)) {
      return (<a href={to} onClick={onClick} className={fullClass}>{loadingEl}{children}</a>);
    }
    return (<Link to={to} className={fullClass}>{loadingEl}{children}</Link>)
  }

  return (
    <button onClick={onClick} onSubmit={onSubmit} disabled={disabled || loading}
      className={fullClass}
    >{loadingEl}{children}
    </button>
  );
};
export default Button;
